import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../../../utils/modal/modal.component';

@Component({
  selector: 'app-confirm-delete-mail-account-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ModalComponent],
  templateUrl: './confirm-delete-mail-account-modal.component.html',
})
export class ConfirmDeleteMailAccountModalComponent {
  /** Set by modal service from data when opening. */
  accountName = '';

  constructor(public modalRef: MdbModalRef<ConfirmDeleteMailAccountModalComponent>) {}
}
